module.exports = __webpack_public_path__ + "img/logo-sm.642a444f.png";